// Reflect shield ability — passive; recovery tick stays in dungeon-update.

import { registerAbility } from '../abilities';
import { G } from '../state';

registerAbility({
  id: 'reflect-shield',
  name: 'Reflect Shield',
  cooldownMs: 0,
  isUnlocked: () => G.player_shield > 0,
  onTick() {
    // Shield HP recovery is handled in updateInlineWorldSim (dungeon-update).
  },
});
